<template>
 <div
    class='product-not-available'>
    <div class='centered thanks-wrapper'>
      <div class='content'>
        <div class='icon'></div>
        <div class='message'>Sorry an error on</div>
        <div class='message'>Slot ID: {{this.result[0].slotID}} for {{this.result[0].eanupc}}</div>
        <div class='message'>{{this.message}}</div>
        <div class="buttons">
          <button @click="retry" v-if="isAvailable">{{$t('retry')}}</button>
          <button @click="goback">{{$t('back')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import initFade from '@/transitions/initFade'
export default {
  name: 'errors',
  props: {
    message: {
      type: String,
      default: 'soldOut',
      validator: function (value) {
        // The value must match one of these strings
        return ['soldOut', 'available', 'NotAvailable'].indexOf(value) !== -1
      }
    },
    result: {
      type: Array,
      default: () => {
        return [{
          slotID: 'TEST',
          eanupc: '12345678901'
        }]
      }
    }
  },
  watch: {
    isAvailable: function (val) {
      return val
    }
  },
  methods: {
    goback () {
      this.$router.push('/products')
    },
    retry () {
      this.$router.push(`/dispenses/${this.result[0].eanupc}`)
    }
  },
  data () {
    return {
      initFade,
      isAvailable: false
    }
  },
  async created () {
    this.initFade.initFade('.icon', 2.8)
    let product = await this.$api.getProduct(this.result[0].eanupc)
    let variants = product.data.result[0][0].variants
    for (let i = 0; i < variants.length; i++) {
      if (variants[i].eanupc === String(this.result[0].eanupc)) {
        this.isAvailable = variants[i].status === 'available'
        break
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@keyframes appearance {
  0%,
  90%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.product-not-available {
  background-color: white;
  background: #000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 1200;

  .content {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    height: 520px;
    max-width: 80vw !important;
  }
  .icon {
    width: 200px;
    height: 200px;
    background: url('../../assets/logo-icon.png') center center no-repeat;
    background-size: contain;
    animation: appearance 3.5s infinite ease-out;
    animation-delay: 1.5s;
    margin-bottom: 50px;
    // -webkit-filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
  }
  .title {
    font-size: 34px;
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
  }
  .message {
    text-align: center;
    font-size: 24px;
    color: #ffffff;
    line-height: 125%;
    margin-top: 15px;
  }
    .buttons {
      margin-top: 15px;
        button {
          background: #fff;
          border: none;
          color: #000000;
          font-size: 18px;
          font-weight: bold;
          text-transform: uppercase;
        }
        button + button {
          margin-left: 40px;
        }
      }
}
</style>
